const matchesAbGroup = (name, {
  min,
  max,
  prefix
}) => {
  if (min === void 0 && max === void 0) return false;
  let cookieVal = getCookie(name);
  if (cookieVal === void 0) return false;
  if (prefix) {
    cookieVal = cookieVal.replace(prefix, "");
  }
  const cookieAsNumber = parseFloat(cookieVal);
  if (isNaN(cookieAsNumber)) return false;
  let result = true;
  if (min && result) {
    result = cookieAsNumber >= min;
  }
  if (max && result) {
    result = cookieAsNumber <= max;
  }
  return result;
};
const getCookie = (name) => {
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
};
export {
  getCookie as g,
  matchesAbGroup as m
};
//# sourceMappingURL=cookie-helpers-PDAUk5j7.js.map
